import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

import Avatar from "vue-boring-avatars";
import {onMounted, ref} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AvatarCard',
  props: {
    name: {
        type: String,
        required: true
    },
    size: {
        default: 35
    },
    title: {
        default: true
    },
    avatarUrl: {
        default: ''
    }
},
  setup(__props) {

const props = __props;

const avatarColors = ["#DF7F7C", "#F3C35D", "#9DD1BE", "#7E8EE3", "#F2EB6F"]


const avatar = ref('');
onMounted(() => {
    if (props.avatarUrl != '' && props.avatarUrl != null&&props.avatarUrl.length>4) {
        let h_ = props.avatarUrl.substring(0,4)
        if (h_!="http") {
            avatar.value = '';
            // process.env.VUE_APP_BASE_API + props.avatarUrl;
        } else {
            avatar.value = props.avatarUrl;
        }
    }
})

return (_ctx: any,_cache: any) => {
  const _component_el_avatar = _resolveComponent("el-avatar")!

  return (avatar.value!='')
    ? (_openBlock(), _createBlock(_component_el_avatar, {
        key: 0,
        size: __props.size,
        src: avatar.value
      }, null, 8, ["size", "src"]))
    : (_openBlock(), _createBlock(_unref(Avatar), {
        key: 1,
        size: __props.size,
        variant: "beam",
        title: __props.title,
        name: __props.name,
        colors: avatarColors
      }, null, 8, ["size", "title", "name"]))
}
}

})